// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  /* border: 1px solid #bcbcbc; */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 10px;
}
.tag-list {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
}
.tag {
  font-size: 13px;
  padding: 3px 3px;
  margin-right: 5px;
  border: 1px solid;
  border-radius: 4px;
  height: auto;
  color: #fff;
  white-space: nowrap;
  background-color: #fff;
}
.more {
  border-color: #fea8ff;
  cursor: pointer;
  color: #000;
}
.notification {
  width: 20vw !important;
  min-width: 200px !important;
}
.align-center {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty {
  border: 1px dotted;
  color: #000;
}
.more-list::-webkit-scrollbar {
  width: 2px !important;
}
.more-list::-webkit-scrollbar-track {
  background: #fff !important;
}
.more-list::-webkit-scrollbar-thumb {
  background: #fea8ff !important;
}
.notification-list {
  cursor: pointer;
  border-radius: 4px;
  padding: 15px 15px !important;
  margin: 2px 0px;
}
.notification-scroll {
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: hidden !important;
  -ms-overflow-style: none;
}
.notification-scroll::-webkit-scrollbar {
  display: block;
}
.bell-noti:hover {
  color: #1677ff;
}
`, "",{"version":3,"sources":["webpack://./src/components/style/index.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,+BAA+B;EAC/B,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;AACF;AAEA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AAAF;AAGA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;AADF;AAIA;EACE,qBAAA;EACA,eAAA;EACA,WAAA;AAFF;AAKA;EACE,sBAAA;EACA,2BAAA;AAHF;AAUA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARF;AAWA;EACE,kBAAA;EACA,WAAA;AATF;AAWA;EACE,qBAAA;AATF;AAYA;EACE,2BAAA;AAVF;AAYA;EACE,8BAAA;AAVF;AAaA;EACE,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AAXF;AAcA;EAEE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,wBAAA;AAbF;AAgBA;EACE,cAAA;AAdF;AAiBA;EACE,cAAA;AAfF","sourcesContent":[".container {\n  width: 100%;\n  /* border: 1px solid #bcbcbc; */\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 5px 10px;\n}\n\n.tag-list {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow: hidden;\n}\n\n.tag {\n  font-size: 13px;\n  padding: 3px 3px;\n  margin-right: 5px;\n  border: 1px solid;\n  border-radius: 4px;\n  height: auto;\n  color: #fff;\n  white-space: nowrap;\n  background-color: #fff;\n}\n\n.more {\n  border-color: #fea8ff;\n  cursor: pointer;\n  color: #000;\n}\n\n.notification {\n  width: 20vw !important;\n  min-width: 200px !important;\n}\n\n// .notification:first-child {\n//   margin-top: 60px !important;\n// }\n\n.align-center {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.empty {\n  border: 1px dotted;\n  color: #000;\n}\n.more-list::-webkit-scrollbar {\n  width: 2px !important;\n}\n\n.more-list::-webkit-scrollbar-track {\n  background: #fff !important;\n}\n.more-list::-webkit-scrollbar-thumb {\n  background: #fea8ff !important;\n}\n\n.notification-list {\n  cursor: pointer;\n  border-radius: 4px;\n  padding: 15px 15px !important;\n  margin: 2px 0px;\n}\n\n.notification-scroll {\n  // width: 320px;\n  height: 100%;\n  overflow: auto;\n  overflow-x: hidden;\n  overflow-y: hidden !important;\n  -ms-overflow-style: none;\n}\n\n.notification-scroll::-webkit-scrollbar {\n  display: block;\n}\n\n.bell-noti:hover{\n  color: #1677ff\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
